(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summit-financing"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
document.querySelectorAll('[data-financing]').forEach(function(root){
if(root.dataset.initialized)return;
root.dataset.initialized='true';
var purchase='all',trailer='all',cards=Array.from(root.querySelectorAll('[data-provider]'));
function update(){
var count=0,special=['concession','porch','pet'].includes(trailer);
cards.forEach(function(card){
var categoryOK=purchase==='all'||card.dataset.purchases.split(',').includes(purchase);
var trailerOK=trailer==='all'||card.dataset.trailers==='all'||card.dataset.trailers.split(',').includes(trailer);
card.hidden=!(categoryOK&&trailerOK);
if(!card.hidden)count++;else{var detail=card.querySelector('details');if(detail)detail.open=false;}
var term=card.querySelector('.sf-conversion-term'),generic=card.querySelector('.sf-generic-term');
if(term)term.hidden=!special;
if(generic)generic.hidden=special;
});
root.querySelectorAll('[data-purchase]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.purchase===purchase));});
root.querySelectorAll('[data-trailer]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.trailer===trailer));});
root.querySelector('[data-result-count]').textContent=count;
root.querySelector('.sf-empty').hidden=count!==0;
}
root.addEventListener('click',function(e){
var b=e.target.closest('button');
if(!b||!root.contains(b))return;
if(b.hasAttribute('data-purchase'))purchase=b.dataset.purchase;
if(b.hasAttribute('data-trailer'))trailer=b.dataset.trailer;
if(b.classList.contains('sf-clear')){purchase='all';trailer='all';}
update();
if(b.classList.contains('sf-hero-option'))root.querySelector('.sf-content').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});
update();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summit-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sh-search').forEach(async function(form) {
  try {
    const response = await fetch(form.action, { credentials: 'same-origin' });
    if (!response.ok) return;
    const inventory = new DOMParser().parseFromString(await response.text(), 'text/html');
    form.querySelectorAll('select').forEach(function(select) {
      const values = Array.from(new Set(Array.from(inventory.querySelectorAll('input[name="' + select.name + '"]')).map(function(input) { return input.value; }).filter(Boolean)));
      if (!values.length) return;
      const selected = select.value;
      select.options.length = 1;
      values.forEach(function(value) { select.add(new Option(value, value)); });
      if (values.includes(selected)) select.value = selected;
    });
  } catch (error) {
    // The server-rendered filter options remain usable if inventory cannot load.
  }
});
document.addEventListener('submit', function(event) {
  if (!event.target.matches('.sh-search')) return;
  event.preventDefault();
  const destination = new URL(event.target.action);
  for (const [name, value] of new FormData(event.target)) {
    if (value) destination.searchParams.append(name, value);
  }
  window.location.assign(destination.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summit-trailer-options"] && !Shopify.designMode) return;
  try {
    
function initializeSummitOptions(scope) {
  scope.querySelectorAll('[data-sto-gallery]').forEach(gallery => {
    if (gallery.dataset.stoReady) return;
    gallery.dataset.stoReady = 'true';
    const dialog = gallery.querySelector('dialog');
    const fullImage = dialog.querySelector('.sto-full-image');
    gallery.querySelectorAll('[data-sto-photo]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        fullImage.src = link.href;
        fullImage.alt = link.querySelector('img').alt;
        dialog.showModal();
      });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });
}
initializeSummitOptions(document);
document.addEventListener('shopify:section:load', event => initializeSummitOptions(event.target));

  } catch(e) { console.error(e); }
})();
})();
